import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TRemoveCommentSucceed, ERemoveCommentActionType } from './types';

export const removeCommentSucceed: (id: number) => TRemoveCommentSucceed = actionGenerator<
  ERemoveCommentActionType.Succeed,
  number
>(ERemoveCommentActionType.Succeed);
